import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clearAllFunnelStorage } from '../services/browserStorageService';
import AppContainer from './Layout/AppContainer';

const ClearStorage = () => {
  const [isClearing, setIsClearing] = useState(false);
  const [isCleared, setIsCleared] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleClearStorage = async () => {
    try {
      setIsClearing(true);
      setError(null);

      // Clear all funnel-related browser storage
      const cleared = clearAllFunnelStorage();
      
      if (cleared) {
        setIsCleared(true);
        
        // Auto-redirect to funnel after 3 seconds
        setTimeout(() => {
          navigate('/optimalpace', { replace: true });
        }, 3000);
      } else {
        setError('Failed to clear browser storage. Please try again.');
      }
    } catch (err) {
      console.error('Error clearing storage:', err);
      setError('An error occurred while clearing storage.');
    } finally {
      setIsClearing(false);
    }
  };

  const handleRedirectNow = () => {
    navigate('/optimalpace', { replace: true });
  };

  return (
    <AppContainer>
      <div style={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        textAlign: 'center',
        background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '16px',
          padding: '32px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
          maxWidth: '500px',
          width: '100%'
        }}>
          {!isCleared ? (
            <>
              <h1 style={{
                color: '#3B515D',
                fontSize: '24px',
                marginBottom: '16px',
                fontWeight: '600'
              }}>
                Clear Browser Storage
              </h1>
              
              <p style={{
                color: '#121616',
                fontSize: '16px',
                lineHeight: '1.5',
                marginBottom: '24px'
              }}>
                This will clear your saved progress and shortcode from this browser. 
                You'll be able to start fresh with a new session.
              </p>

              {error && (
                <div style={{
                  background: '#f8d7da',
                  color: '#721c24',
                  padding: '12px',
                  borderRadius: '8px',
                  marginBottom: '24px',
                  fontSize: '14px'
                }}>
                  {error}
                </div>
              )}

              <div style={{
                display: 'flex',
                gap: '12px',
                justifyContent: 'center',
                flexWrap: 'wrap'
              }}>
                <button
                  onClick={handleClearStorage}
                  disabled={isClearing}
                  style={{
                    background: isClearing 
                      ? '#6c757d' 
                      : 'linear-gradient(135deg, #dc3545 0%, #c82333 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '12px 24px',
                    fontSize: '16px',
                    fontWeight: '500',
                    cursor: isClearing ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s ease',
                    minWidth: '120px'
                  }}
                  onMouseEnter={(e) => {
                    if (!isClearing) {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 4px 12px rgba(220, 53, 69, 0.3)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isClearing) {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }
                  }}
                >
                  {isClearing ? 'Clearing...' : 'Clear Storage'}
                </button>

                <button
                  onClick={() => navigate('/optimalpace')}
                  disabled={isClearing}
                  style={{
                    background: 'linear-gradient(135deg, #6c757d 0%, #5a6268 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    padding: '12px 24px',
                    fontSize: '16px',
                    fontWeight: '500',
                    cursor: isClearing ? 'not-allowed' : 'pointer',
                    transition: 'all 0.2s ease',
                    minWidth: '120px'
                  }}
                  onMouseEnter={(e) => {
                    if (!isClearing) {
                      e.target.style.transform = 'translateY(-2px)';
                      e.target.style.boxShadow = '0 4px 12px rgba(108, 117, 125, 0.3)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!isClearing) {
                      e.target.style.transform = 'translateY(0)';
                      e.target.style.boxShadow = 'none';
                    }
                  }}
                >
                  Cancel
                </button>
              </div>
            </>
          ) : (
            <>
              
              <h1 style={{
                color: '#28a745',
                fontSize: '24px',
                marginBottom: '16px',
                fontWeight: '600'
              }}>
                Storage Cleared
              </h1>
              
              <p style={{
                color: '#121616',
                fontSize: '16px',
                lineHeight: '1.5',
                marginBottom: '24px'
              }}>
                Your browser storage has been cleared successfully. 
                You'll be redirected to Optimal Pace Academy in a moment...
              </p>

              <button
                onClick={handleRedirectNow}
                style={{
                  background: 'linear-gradient(135deg, #405C73 0%, #435F60 100%)',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '12px 24px',
                  fontSize: '16px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(64, 92, 115, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                Go to Optimal Pace Academy Now
              </button>
            </>
          )}
        </div>

        <div style={{
          marginTop: '24px',
          color: '#6c757d',
          fontSize: '14px'
        }}>
        </div>
      </div>
    </AppContainer>
  );
};

export default ClearStorage;
